import React, { useEffect } from "react";
import PageHeader from "./PageHeader";
import Table from "./Table";
import { useDispatch, useSelector } from "react-redux";
import {
  getDepartments,
  getGroups,
} from "../../../../Redux/Actions/skill_matrix_actions";

const SkillGroup = () => {
  const { departments, groups } = useSelector((state) => state.skillMatrix);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!departments) dispatch(getDepartments());
    if (!groups) dispatch(getGroups());
  }, []);

  return (
    <>
      <PageHeader />
      <Table />
    </>
  );
};

export default SkillGroup;
